/**
 * Helpers to build per-page Open Graph image URLs served by the
 * `og-image` edge function.
 *
 * Static pages use deterministic SVG -> PNG (cheap, fast, on-brand).
 * Blog posts use AI-generated covers cached in Supabase Storage.
 */
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const FN_BASE = `${SUPABASE_URL}/functions/v1/og-image`;

export type OgStaticPage =
  | "home"
  | "about"
  | "blog"
  | "contact"
  | "case-studies"
  | "projects"
  | "ai";

export function ogStatic(page: OgStaticPage): string {
  return `${FN_BASE}/static?page=${page}`;
}

export function ogBlog(slug: string): string {
  return `${FN_BASE}/blog?slug=${encodeURIComponent(slug)}`;
}

